import { getTimeZoneDifference } from '@/utils/availability';
import { Booking, CreateBooking } from './booking';
import { DateTime } from "luxon";

export type BookingCheckoutCreateResult = {
  clientSecret: string;
  stripePublishableKey: string;
  booking: Booking;
};

export interface BookingCheckoutMixin {
  clientTimezone?: string | undefined;
  fetch(path: string, init?: RequestInit): Promise<any>;
  bookingCheckoutCreate(
    extension: string,
    booking: CreateBooking
  ): Promise<BookingCheckoutCreateResult>;
}

export const BookingCheckoutMixin = {
  async fetch(path: string, init?: RequestInit): Promise<any> {
    throw new Error('Not implemented');
  },
  async bookingCheckoutCreate(
    extension: string,
    booking: CreateBooking
  ): Promise<BookingCheckoutCreateResult> {
    const timeZone = this.clientTimezone
      ? this.clientTimezone
      : DateTime.local().zoneName;
    const res = await this.fetch(`/booking_checkout?extension=${extension}`, {
      method: 'POST',
      body: JSON.stringify({
        booking: { ...booking, startDate: new Date(booking.startDate) },
      }),
    });
    return res;
  },
} as BookingCheckoutMixin;
